export default __webpack_public_path__ + "assets/images/a07be2d4aa048fd02b9f4b445bdf2592.png";